import { type ReactNode, useEffect, useState } from 'react';
import { SiteHeader } from './SiteHeader';
import { SiteNav } from './SiteNav';
import { SiteFooter } from './SiteFooter';

interface PageLayoutProps {
  children: ReactNode;
  spaceAbove?: boolean;
  hideFooter?: boolean;
}

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() { setVisible(window.scrollY > 300); }
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      className={`scroll-to-top${visible ? ' scroll-to-top--visible' : ''}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      title="Back to top"
    >
      ↑
    </button>
  );
}

export function PageLayout({ children, spaceAbove = true, hideFooter = false }: PageLayoutProps) {
  return (
    <>
      <header>
        <SiteHeader />
        <SiteNav />
      </header>
      <main role="main" className={spaceAbove ? 'space-above' : undefined}>
        {children}
      </main>
      {!hideFooter && <SiteFooter />}
      <ScrollToTopButton />
    </>
  );
}
